var CAR_CATEGORY_OPTIONS = [
    {
        key: "carSmall",
        id: "fib_ab",
        value: "M|N|E|H:::"
    },
    {
        key: "carFullSize",
        id: "fib_al",
        value: "S|F|R|G|X|P|U|L|W:::"
    },
    {
        key: "carCompact",
        id: "fib_ad",
        value: "C|D:-V|-M::"
    },
    {
        key: "carWagonEstate",
        id: "fib_ae",
        value: ":W|Y::"
    },
    {
        key: "carMiddleClass",
        id: "fib_af",
        value: "I|J|S|F|R|G|X|P|U|L|W:::"
    }, 
];
var EXTRA_OPTIONS = [
    {
        key: "kmFree",
        id: "fib_ed",
        value: "a[K*]",
        name: "extras[]"
    },
    {
        key: "fairFuelPolicy",
        id: "fib_ee",
        value: "full-full",
        name: "fuel_policy[]"
    },
    {
        key: "additionalDriver",
        id: "fib_ec",
        value: "a[A]",
        name: "extras[]"
    },
    {
        key: "winterTires",
        id: "fib_eb",
        value: "a[W]",
        name: "extras[]"
    }, 
];
export { CAR_CATEGORY_OPTIONS, EXTRA_OPTIONS };
